// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dendrogram-close-bttn{
    position: absolute;
    top: 0px;
    color: #9497a0;
    right: 0px;
    font-size: 18px;
    z-index: 1000;
    background-color: white;
    padding-top: 3px;
}

.dendrogram-assign-clusters-bttn {
    position: absolute;
    top: 0px;
    color: #9497a0;
    left: 3px;
    font-size: 14px;
    z-index: 1000;
    background-color: white;
    padding-top: 5px;
}

.dendrogram-overlay{
    position: absolute;
    background-color: white;
    overflow-y: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.dendrogram-loader{
    display: flex;
    justify-content: center;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/css/injected-dendrogram.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,UAAU;IACV,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,SAAS;IACT,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".dendrogram-close-bttn{\n    position: absolute;\n    top: 0px;\n    color: #9497a0;\n    right: 0px;\n    font-size: 18px;\n    z-index: 1000;\n    background-color: white;\n    padding-top: 3px;\n}\n\n.dendrogram-assign-clusters-bttn {\n    position: absolute;\n    top: 0px;\n    color: #9497a0;\n    left: 3px;\n    font-size: 14px;\n    z-index: 1000;\n    background-color: white;\n    padding-top: 5px;\n}\n\n.dendrogram-overlay{\n    position: absolute;\n    background-color: white;\n    overflow-y: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.dendrogram-loader{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
